// Screen `change-sets` (owner: platform-agent, settings IA): Inbox › Change sets, the approval queue and history
// of the agent's change sets (formerly Settings › AI › Change sets). `?id=` opens one of them.
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { ChangeSetsPage } from '../../features/ai-changes/ChangeSetsPage';

export const Route = createFileRoute('/_app/change-sets')({
  validateSearch: z.object({ id: z.uuid().optional().catch(undefined) }),
  component: function ChangeSetsRoute() {
    return <ChangeSetsPage focus={Route.useSearch().id} />;
  },
});
